/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { WorkPackageDynamicFormsDto } from '../../models/work-package-dynamic-forms-dto';

export interface GetTemplateDynamicForms$Params {
  id: string;
}

export function getTemplateDynamicForms(http: HttpClient, rootUrl: string, params: GetTemplateDynamicForms$Params, context?: HttpContext): Observable<StrictHttpResponse<WorkPackageDynamicFormsDto>> {
  const rb = new RequestBuilder(rootUrl, getTemplateDynamicForms.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<WorkPackageDynamicFormsDto>;
    })
  );
}

getTemplateDynamicForms.PATH = '/v0/templates/{id}/dynamic-forms';
